// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let StrategySubscriptionStatus =
{
    NotAccepted: 0,
    Accepted: 1,
    Deleted: 2
}